import getMenuItems from "@/api/requests/wordpress/getMenuItems";
import getPages from "@/api/requests/wordpress/getPages";
import getYoastRedirect from "@/api/requests/wordpress/getYoastRedirect";
import { MenuItems, Page } from "@/custom-types/Wordpress";
import { createGetServerSideProps } from "@/utils/createGetServerSideProps";
import { getUrlPath } from "@/utils/getUrlPath";
import { redirectToPreviewPage } from "@/utils/news/redirect";
import { getCountryCodeHeader } from "@/utils/requestContext";

import ArticleContent from "@/components/news/ArticleContent";
import PageLayout from "@/components/news/Layouts/PageLayout";

type LearnPageProps = {
  menuItems: MenuItems;
  page: Page;
};

const LearnPage: React.FC<LearnPageProps> = ({ menuItems, page }) => {
  return (
    <PageLayout menuItems={menuItems} page={page}>
      <ArticleContent item={page} />
    </PageLayout>
  );
};

export const getServerSideProps = createGetServerSideProps<LearnPageProps>(
  async (context) => {
    const {
      query: { preview_id, preview, page_id },
      resolvedUrl,
    } = context;
    const redirect = await getYoastRedirect(getUrlPath(resolvedUrl));

    if (redirect?.destination) {
      return {
        redirect,
      };
    }

    const isPreview =
      (preview_id || page_id) && (preview === "true" || preview === "1");
    if (isPreview) {
      return redirectToPreviewPage((preview_id || page_id) as string, "page");
    }

    const countryCode = getCountryCodeHeader(context.req.headers);

    const { pages } = await getPages(countryCode, { slug: "learn" }, "1", "1");
    const page = pages?.[0];

    if (!page) {
      return {
        notFound: true,
      };
    }

    const menuItems = await getMenuItems("learn");

    return {
      props: {
        menuItems,
        page,
      },
    };
  },
);

export default LearnPage;
